import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { LoadableUserTimezoneCheck } from './loadable';
import { currentUserIdSelector } from '../../../ReduxStorage/Auth/selectors';

const _MountableUserTimezoneCheck = (props) => {
  // check newBase.html for existance of this element
  const targetElement = document.getElementById('user-timezone-check-mount');
  const { currentUserId } = props;

  if (!targetElement || !currentUserId) {
    return null;
  }

  return ReactDOM.createPortal(
    <LoadableUserTimezoneCheck {...props} />,
    targetElement
  );
};

const mapState = (state) => {
  return {
    currentUserId: currentUserIdSelector(state),
  };
};

export const MountableUserTimezoneCheck = connect(mapState)(
  _MountableUserTimezoneCheck
);
